import { render, staticRenderFns } from "./formAddress.vue?vue&type=template&id=7225227a&"
import script from "./formAddress.vue?vue&type=script&lang=js&"
export * from "./formAddress.vue?vue&type=script&lang=js&"
import style0 from "./formAddress.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports